import Elemento from './Elemento.js';

export default class Caracteristica extends Elemento {
  constructor() {
    super();
    this.center = null;
    this.relaciones = null;
    this.seleccion = new Object();
    this.tipo = new Object();
    this.step = new Number();
    this.valorDef = new Number() || new String();
    this.getStep = function () {
      const seleccion = this.seleccion;
      return Number(eval(this.step));
    };
    this.min = null;
    this.getMin = function () {
      const seleccion = this.seleccion;
      return Number(eval(this.min).toFixed(3));
    };
    this.max = null;
    this.getMax = function () {
      const seleccion = this.seleccion;
      let maxValue = Number(eval(this.max).toFixed(3));
      let minValue = this.getMin();

      return maxValue < minValue ? minValue : maxValue;
    };
    this.valorSel = new Number() || new String();
    this.referencias = new Array();
    this.valores = new Array();
    this.getValor = function (param) {
      var element = param == undefined ? (element = this.valorSel) : param;

      var filter = this.valores.find((valorEl) => valorEl.cod == element);

      return filter != undefined ? filter : this.valores[0];
    };
    this.getValorSel = function () {
      return this.getValor(this.valorSel);
    };
    this.filtros = new Array();
    this.getFiltro = function (param) {
      var filter = this.filtros.find((filtroEl) => filtroEl.cod == param);

      return filter != undefined ? filter : this.filtros[0];
    };
    this.condicion = true;
    this.resolveCondicion = function () {
      const seleccion = this.seleccion;
      return eval(this.condicion);
    };
  }
}
